import { useEffect, useRef, useState } from "react";
import { AngularBridge } from "../../other/bridgeSetup/AngularBridge";
import { useSingleton } from "../../other/injection";
import { LoggedInUserStore } from "../../other/loggedInUser/LoggedInUserStore";

interface IProps {
    search: string;
}

export const SearchPage = ({ search }: IProps) => {
    const loggedInUserStore = useSingleton(LoggedInUserStore);

    const [key, setKey] = useState(0);
    const firstEffectRef = useRef(true);
    useEffect(() => {
        if (search !== "" && !firstEffectRef.current) {
            // update key when location search params change (other than blank because that happens automatically)
            // a key update will cause the feed to reset
            // this allows triggering default selection changes even when already on the feed page
            setKey(x => x + 1);
        }
        firstEffectRef.current = false;
    }, [search]);

    return (
        <AngularBridge
            name="c-search-route"
            key={key}
            props={{
                topTitle: loggedInUserStore.hasPermission(
                    RedDeer.Contracts.Enums.PermissionType.CanAccessMifid
                )
                    ? "Catch up"
                    : "Search data"
            }}
        />
    );
};
